// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const HelpMd = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M18.182 10.0001C18.182 14.5188 14.5189 18.1819 10.0002 18.1819C5.48149 18.1819 1.81836 14.5188 1.81836 10.0001C1.81836 5.48136 5.48149 1.81824 10.0002 1.81824C14.5189 1.81824 18.182 5.48136 18.182 10.0001Z" stroke={color} strokeWidth="1.5" />
        <path d="M8.63623 6.97918C8.96941 6.60172 9.45687 6.36365 9.99987 6.36365C11.004 6.36365 11.818 7.17767 11.818 8.18183C11.818 9.03065 11.2363 9.74365 10.4498 9.94392C10.2065 10.0058 9.99987 10.2036 9.99987 10.4546V10.9091" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 13.6364H10.0087" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);
